import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getPaginatedNotifications = async ({
  page = 1,
  pageSize = 25,
  search = '',
  workOrderId,
  notificationStatusId,
  priorityId,
  teamsId,
  assetId,
  areaId,
  locationId,
  departmentId,
  onlyWithTeamsAssigned,
  startDate,
  endDate,
  sortField,
  sortOrder,
} = {}) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/notifications`, {
      params: {
        page,
        pageSize,
        search,
        workOrderId,
        notificationStatusId,
        priorityId,
        teamsId,
        assetId,
        areaId,
        locationId,
        departmentId,
        onlyWithTeamsAssigned,
        startDate,
        endDate,
        sortField,
        sortOrder,
      },
      paramsSerializer: (params) => {
        const query = new URLSearchParams();
        for (const key in params) {
          const value = params[key];
          if (Array.isArray(value)) {
            value.forEach((v) => query.append(key, v));
          } else if (value !== undefined && value !== null) {
            query.append(key, value);
          }
        }
        return query.toString();
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching notifications:', error.response?.data || error);
    throw error;
  }
};

// GET a single notification
export const getNotificationById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/notifications/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching notification:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new notification
export const createNotification = async (notificationData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/notifications`, notificationData);
    return response.data;
  } catch (error) {
    console.error("Error creating notification:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new notification with AI
export const createNotificationWithAi = async (text) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/ai-notifications`, { text });
    return response.data;
  } catch (error) {
    console.error("Error creating notification with AI:", error.response?.data || error);
    throw error;
  }
};

export const approveNotification = async (payload) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/notifications/approve`, payload);
    return response.data;
  } catch (error) {
    console.error('Error approving notification:', error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing notification
export const updateNotification = async (id, notificationData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/notifications/${id}`, notificationData);
    return response.data;
  } catch (error) {
    console.error("Error updating notification:", error.response?.data || error);
    throw error;
  }
};

// DELETE a notification
export const deleteNotification = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/notifications/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting notification:", error.response?.data || error);
    throw error;
  }
};
